// extracted by mini-css-extract-plugin
module.exports = {"form":"form--48b+u","backLink":"backLink--Hj4J+","backButton":"backButton--eNSDE","submitButton":"submitButton--vsbEn"};